export function extractOnlyNumFromString(strNum) {
	// '$23,231,12' => 2323112
	// null or undefined => 0
	let numericalVal;
	if (strNum) {
		numericalVal = strNum.toString()?.replace(/\D/g, '');
	}
	return Number(numericalVal) || 0;
}
